/**
 * Disable Flickity slider on the cart "Did you know?" upsell so native
 * horizontal scroll works. Watches for our wrapper appearing/re-rendering
 * and destroys any Flickity instance attached to it.
 */
(function () {
  function destroyFlickityOn(el) {
    if (!el) return;
    var Flickity = window.Flickity || (window.theme && window.theme.Flickity);
    if (!Flickity || typeof Flickity.data !== 'function') return;
    var instance = Flickity.data(el);
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy();
    }
    el.classList.remove('flickity-enabled', 'is-draggable');
  }

  function sweep(root) {
    var nodes = (root || document).querySelectorAll('[data-pair-products].cart-upsell--vertical');
    nodes.forEach(destroyFlickityOn);
  }

  function init() {
    sweep(document);

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && m.addedNodes.length) {
          // Defer so Flickity init (which runs on cart re-render) finishes first.
          setTimeout(function () { sweep(document); }, 0);
          return;
        }
        if (m.type === 'attributes' && m.target && m.target.matches && m.target.matches('[data-pair-products].cart-upsell--vertical')) {
          setTimeout(function () { destroyFlickityOn(m.target); }, 0);
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
